import { render, staticRenderFns } from "./PopupMatchingRequest.vue?vue&type=template&id=558f5482&scoped=true"
import script from "./PopupMatchingRequest.vue?vue&type=script&lang=js"
export * from "./PopupMatchingRequest.vue?vue&type=script&lang=js"
import style0 from "./PopupMatchingRequest.vue?vue&type=style&index=0&id=558f5482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558f5482",
  null
  
)

export default component.exports